import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
import App from "./App";
import ErrorPage from "./screens/errorPage";
import { getInitialConfig } from "./api/requests";
import { tipoPlanoConfig } from "./utils/constants";
import getMycoins from "./utils/getMycoins";
import mycoinsBot from "./config/mycoinsBot";
import { getRemoteValueEnv, setupFirebaseRemoteConfig, setupDatadog } from "./setup";

// Inicializa Firebase Remote Config e Datadog antes de tudo
await setupFirebaseRemoteConfig();
setupDatadog();

let routes = [];

const hostname = window.location.hostname;
const isDev = hostname.includes("dev") || hostname.includes("localhost");

const firebaseMycoins = JSON.parse(
  getRemoteValueEnv("mycoins_dev", "mycoins_prod").asString()
);

const isSiteDomainRoot = (siteDomain) => {
  const url = new URL(siteDomain);
  return url.pathname === "/";
};

const isDomainMatch = (offer) => {
  return offer.siteDomain.includes(hostname);
};

const getInitialConfigs = (hasMycoins, jsonConfig) => {
  const mycoinsConfig = firebaseMycoins ? [firebaseMycoins] : mycoinsBot;
  return hasMycoins ? mycoinsConfig : jsonConfig;
};

const getRoutes = (jsonConfig) => {
  const errorPage = {
    path: "*",
    element: <ErrorPage />,
  };

  const hasMycoins = !!getMycoins();
  const initialConfigs = getInitialConfigs(hasMycoins, jsonConfig);

  const routesMap = initialConfigs.map((config) => {
    let newRoute = null;

    if (isDev || (!isDev && isDomainMatch(config))) {
      const botConfig = {
        route: config.route,
        title: config.title,
        description: config.description,
        allowIndexing: config.allowIndexing
          ? "index, follow"
          : "noindex, nofollow",
        campanhaId: config.campanhaId,
        compraId: config.compraId,
        empresaId: config.empresaId,
        desconto: config.desconto,
        navBar: config.navbar,
        isApp: config.isApp,
        tipoTabela: config.tipoTabela,
        brand: config.brand,
        gtmId: config.gtmId,
        siteDomain: config.siteDomain,
        bannerSrc: config.bannerSrc,
        linkWhatsApp: config.linkWhatsApp,
        tipoPlano:
          tipoPlanoConfig[config.tipoTabela ?? tipoPlanoConfig.completa],
        shouldUseCoupon: config.shouldUseCoupon,
        copyMessage: config.copyMessage,
        theme: {
          inputs: {
            color: config.theme[0].inputs.color,
            backgroundColor: config.theme[0].inputs.backgroundColor,
          },
          buttons: {
            color: config.theme[0].buttons.color,
            backgroundColor: config.theme[0].buttons.backgroundColor,
          },
          hostBubbles: {
            color: config.theme[0].hostBubbles.color,
            backgroundColor: config.theme[0].hostBubbles.backgroundColor,
          },
          guestBubbles: {
            color: config.theme[0].guestBubbles.color,
            backgroundColor: config.theme[0].guestBubbles.backgroundColor,
          },
          backgroundColor: config.theme[0].backgroundColor,
        },
        seguro: config.seguro ?? "false",
        button_color_text: config.button_color_text ?? config.theme[0].buttons.color,
        button_color_background: config.button_color_background ?? config.theme[0].buttons.backgroundColor,
      };

      newRoute = {
        path:
          !isDev && isDomainMatch(config) && isSiteDomainRoot(config.siteDomain)
            ? "/"
            : config.route,
        element: <App {...botConfig} />,
      };
    }

    return newRoute;
  });

  routes = [...routesMap, errorPage].filter((route) => !!route && !!route.path);
};

await getInitialConfig().then((initialConfigElements) => {
  if (initialConfigElements && initialConfigElements.length > 0) {
    getRoutes(initialConfigElements);
  }
});

const router = createBrowserRouter(routes);

export default router;
